import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/pexels-thirdman-7652126.jpg";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Request for Services"
				subtitle=""
				breadcrumbText="Request for Services"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}